'use client';

import { FC, useEffect, useState } from 'react';

import { usePathname } from '@telialt/utils/src/pathname';

import { MaintenanceBanner as MaintenanceBannerModel, MaintenanceResponseData } from '../../model';
import { MaintenanceBanner } from './MaintenanceBanner';

type Props = {
    data: MaintenanceResponseData;
};

export const Maintenance: FC<Props> = ({ data }) => {
    const maintenanceBanners = data?.maintenanceBanners;
    const pathname = usePathname();
    const [matchingBanner, setMatchingBanner] = useState<MaintenanceBannerModel | null>(null);

    const handleBannerClose = ({ cookieName, cookieExpiration }: MaintenanceBannerModel) => {
        const expirationDate = new Date();
        expirationDate.setTime(expirationDate.getTime() + cookieExpiration * 24 * 60 * 60 * 1000);
        document.cookie = `${cookieName}=true;expires=${expirationDate.toUTCString()};path=/`;
    };

    useEffect(() => {
        setMatchingBanner(
            maintenanceBanners?.find((banner) => {
                const hasCookie = document.cookie
                    .split(';')
                    .some((cookie) => cookie.trim().startsWith(`${banner.cookieName}=`));

                if (hasCookie) {
                    return false;
                }

                if (!banner.urlPattern) {
                    return true;
                }

                return pathname?.startsWith(banner.urlPattern);
            }),
        );
    }, [maintenanceBanners, pathname]);

    if (!matchingBanner) {
        return null;
    }

    return <MaintenanceBanner data={matchingBanner} onClose={handleBannerClose} />;
};
